export default "__VITE_ASSET__3495ba5f__"